import { render, staticRenderFns } from "./PaymentIntegrationsList.vue?vue&type=template&id=149d3cbc&scoped=true"
import script from "./PaymentIntegrationsList.vue?vue&type=script&lang=js"
export * from "./PaymentIntegrationsList.vue?vue&type=script&lang=js"
import style0 from "./PaymentIntegrationsList.vue?vue&type=style&index=0&id=149d3cbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149d3cbc",
  null
  
)

export default component.exports